import type { RequestOptions, Transport } from '@ironview-360/api-client';
import { request } from './requests';

/** Shared resources use the host's existing CSRF, cookie and AppError pipeline. */
export const packageTransport: Transport = {
  async request<T>(method: string, path: string, options: RequestOptions = {}): Promise<T> {
    const query = new URLSearchParams();
    for (const [key, value] of Object.entries(options.query ?? {})) {
      if (value !== undefined && value !== null) query.set(key, String(value));
    }
    const response = await request(
      method.toLowerCase() as 'get' | 'post' | 'put' | 'patch' | 'delete',
      `${path}${query.size ? `?${query}` : ''}`, options.body, options.headers, options.signal,
    );
    return response.data as T;
  },
};
